<div class="loading-container padding flex-centered-container">
    <div class="text-center">
      <!-- Logo/Brand Section -->
      <div class="logo-section display-flex justify-center position-relative margin-32-bot">
        <div class="glow-effect"></div>
        <div class="logo-card bg-white border-radius-16 padding">
          <img class="logo loading-icon" src="/assets/uTradeAlgos.svg"/>
        </div>
      </div>

      <!-- Loading Animation -->
      <div class="dots-container display-flex justify-center margin-24-bottom gap-8-px">
        <div class="dot dot-1 border-radius-full bg-primary"></div>
        <div class="dot dot-2 border-radius-full bg-primary"></div>
        <div class="dot dot-3 border-radius-full bg-primary"></div>
      </div>

      <!-- Loading Text -->
      <h2 class="loading-title font-bold no-margin margin-8-bottom font-24 primary-dark-text">Loading Your Plans</h2>
      <p class="loading-subtitle no-margin font-14 text-dark">Please wait while we fetch your subscription details...</p>

      <!-- Progress Bar -->
      <div class="progress-container margin-32-top margin-auto-hr">
        <div class="progress-track">
          <div class="progress-bar"></div>
        </div>
      </div>

      <!-- Additional Info -->
      <div class="secure-text margin-top-50 font-12 placeholder-text">Retrieving your plan options...</div>
    </div>
  </div>